import { render, staticRenderFns } from "./toushuTbale.vue?vue&type=template&id=97a208d4&scoped=true"
import script from "./toushuTbale.vue?vue&type=script&lang=js"
export * from "./toushuTbale.vue?vue&type=script&lang=js"
import style0 from "./toushuTbale.vue?vue&type=style&index=0&id=97a208d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a208d4",
  null
  
)

export default component.exports